import styled from "styled-components";

import { SelectTrigger } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const NoTouchPurchaseSummaryModalSelection = styled(Flex)`
    padding: 24px 32px 32px 0;
`;

export const StyledNoTouchPurchaseSelectTrigger = styled(SelectTrigger)`
    width: 100%;
`;
